import { Divider, styleMixinFocusOutline, Text } from '@amzn/storm-ui';
import styled, { css } from 'styled-components';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

const pivotWidth = '212px';

export const PivotWrap = styled.nav`
  display: flex;
  flex-direction: column;
  width: ${pivotWidth};
  height: 100%;
  position: relative;
  padding: 18px 14px;
  box-sizing: border-box;

  [class*='PopperTrigger'] {
    display: inline;
  }

  & > * {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const PivotNavWrapper = styled.div`
  & nav {
    padding-inline-start: ${({ theme }) => theme.spacing.small.mobile};
  }
`;

export const PivotDivider = styled(Divider)`
  margin-block: ${({ theme }) => theme.spacing.xxxsmall.default};
  border-bottom: thin solid ${({ theme }) => theme.color.gray[200]};
`;

interface ItemProp extends StyledComponentsPropWithTheme {
  active: boolean;
}

const sharedItemStyles = css<ItemProp>`
  border: none;
  display: flex;
  align-items: center;
  padding: 10px 8px;
  color: ${({ theme }) => theme.color.gray[900]};
  text-align: left;
  border-radius: ${({ theme }) => theme.border.radius.small};
  box-sizing: border-box;
  justify-content: space-between;
  ${(props) =>
    props.active
      ? css`
          font-weight: bold;
          background-color: ${(props) =>
            props.theme.pivotNav.buttonBackgroundActive};
        `
      : css`
          font-family: inherit;
          background-color: unset;
        `};

  &:hover {
    background-color: ${(props) => props.theme.pivotNav.buttonBackgroundHover};
  }

  :focus-visible,
  :focus {
    ${styleMixinFocusOutline};
  }
`;

export const ItemLink = styled.a<ItemProp>`
  text-decoration: none;

  ${sharedItemStyles}
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.color.gray[900]};
  }
`;

export const ItemButton = styled.button<ItemProp>`
  width: 100%;
  cursor: pointer;
  ${sharedItemStyles}
`;

export const ItemText = styled(Text)`
  color: ${({ theme }) => theme.color.gray[900]};
  font-weight: inherit;
`;

export const GroupTitleWrapper = styled.div`
  padding: 10px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GroupTitle = styled(Text)`
  background: none;
  border: none;
  outline: none;
  display: block;
  margin-bottom: 1px;
  padding: 0;
  color: ${({ theme }) => theme.color.gray[800]};
  text-align: left;
  border-radius: ${({ theme }) => theme.border.radius.small};
  box-sizing: border-box;
  font-weight: 700;
`;

export const GroupLinksWrapper = styled.div<{ hasLabel?: boolean }>`
  ${({ hasLabel }) =>
    hasLabel &&
    css`
      padding-inline-start: 6px;
    `}
  > span {
    width: 100%;
  }
`;

export const MobilePivot = styled.div`
  width: calc(100% + 18px);

  & ul {
    display: block;
  }
`;
